/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { Synthesis, SynthesisInterface } from '../Synthesis'

const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'bytes32',
                name: 'id',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'chainID',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'revertableAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
        ],
        name: 'BurnRequest',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'bytes32',
                name: 'requestId',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'clientId',
                type: 'bytes32',
            },
        ],
        name: 'ClientIdLog',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'Paused',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'id',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'bridgingFee',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
        ],
        name: 'RevertBurnCompleted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'id',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
        ],
        name: 'RevertSynthesizeRequest',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'fabric',
                type: 'address',
            },
        ],
        name: 'SetFabric',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'metaRouter',
                type: 'address',
            },
        ],
        name: 'SetMetaRouter',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'threshold',
                type: 'uint256',
            },
        ],
        name: 'SetTokenThreshold',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'id',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'bridgingFee',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
        ],
        name: 'SynthesizeCompleted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'Unpaused',
        type: 'event',
    },
    {
        inputs: [],
        name: 'bridge',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_stableBridgingFee',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '_stoken',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_amount',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '_chain2address',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_receiveSide',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_oppositeBridge',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_revertableAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_chainID',
                type: 'uint256',
            },
            {
                internalType: 'bytes32',
                name: '_clientID',
                type: 'bytes32',
            },
        ],
        name: 'burnSyntheticToken',
        outputs: [
            {
                internalType: 'bytes32',
                name: 'internalID',
                type: 'bytes32',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'fabric',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_bridge',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_trustedForwarder',
                type: 'address',
            },
            {
                internalType: 'contract IMetaRouter',
                name: '_metaRouter',
                type: 'address',
            },
        ],
        name: 'initialize',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'forwarder',
                type: 'address',
            },
        ],
        name: 'isTrustedForwarder',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'stableBridgingFee',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'address',
                        name: 'syntCaller',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'finalReceiveSide',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'sToken',
                        type: 'address',
                    },
                    {
                        internalType: 'bytes',
                        name: 'finalCallData',
                        type: 'bytes',
                    },
                    {
                        internalType: 'uint256',
                        name: 'finalOffset',
                        type: 'uint256',
                    },
                    {
                        internalType: 'address',
                        name: 'chain2address',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'receiveSide',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'oppositeBridge',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'revertableAddress',
                        type: 'address',
                    },
                    {
                        internalType: 'uint256',
                        name: 'chainID',
                        type: 'uint256',
                    },
                    {
                        internalType: 'bytes32',
                        name: 'clientID',
                        type: 'bytes32',
                    },
                ],
                internalType: 'struct MetaRouteStructs.MetaBurnTransaction',
                name: '_metaBurnTransaction',
                type: 'tuple',
            },
        ],
        name: 'metaBurnSyntheticToken',
        outputs: [
            {
                internalType: 'bytes32',
                name: 'internalID',
                type: 'bytes32',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'stableBridgingFee',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'bytes32',
                        name: 'externalID',
                        type: 'bytes32',
                    },
                    {
                        internalType: 'address',
                        name: 'tokenReal',
                        type: 'address',
                    },
                    {
                        internalType: 'uint256',
                        name: 'chainID',
                        type: 'uint256',
                    },
                    {
                        internalType: 'address',
                        name: 'to',
                        type: 'address',
                    },
                    {
                        internalType: 'address[]',
                        name: 'swapTokens',
                        type: 'address[]',
                    },
                    {
                        internalType: 'address',
                        name: 'secondDexRouter',
                        type: 'address',
                    },
                    {
                        internalType: 'bytes',
                        name: 'secondSwapCalldata',
                        type: 'bytes',
                    },
                    {
                        internalType: 'address',
                        name: 'finalReceiveSide',
                        type: 'address',
                    },
                    {
                        internalType: 'bytes',
                        name: 'finalCalldata',
                        type: 'bytes',
                    },
                    {
                        internalType: 'uint256',
                        name: 'finalOffset',
                        type: 'uint256',
                    },
                ],
                internalType: 'struct MetaRouteStructs.MetaMintTransaction',
                name: '_metaMintTransaction',
                type: 'tuple',
            },
        ],
        name: 'metaMintSyntheticToken',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'metaRouter',
        outputs: [
            {
                internalType: 'contract IMetaRouter',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_stableBridgingFee',
                type: 'uint256',
            },
            {
                internalType: 'bytes32',
                name: '_externalID',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: '_tokenReal',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_chainID',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_amount',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '_to',
                type: 'address',
            },
        ],
        name: 'mintSyntheticToken',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'pause',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'paused',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'requestCount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        name: 'requests',
        outputs: [
            {
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'chain2address',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'stoken',
                type: 'address',
            },
            {
                internalType: 'enum Synthesis.RequestState',
                name: 'state',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_stableBridgingFee',
                type: 'uint256',
            },
            {
                internalType: 'bytes32',
                name: '_externalID',
                type: 'bytes32',
            },
        ],
        name: 'revertBurn',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_stableBridgingFee',
                type: 'uint256',
            },
            {
                internalType: 'bytes32',
                name: '_internalID',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: '_receiveSide',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_oppositeBridge',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_chainID',
                type: 'uint256',
            },
            {
                internalType: 'bytes32',
                name: '_clientID',
                type: 'bytes32',
            },
        ],
        name: 'revertSynthesizeRequest',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_fabric',
                type: 'address',
            },
        ],
        name: 'setFabric',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'contract IMetaRouter',
                name: '_metaRouter',
                type: 'address',
            },
        ],
        name: 'setMetaRouter',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_token',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_threshold',
                type: 'uint256',
            },
        ],
        name: 'setTokenThreshold',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        name: 'synthesizeStates',
        outputs: [
            {
                internalType: 'enum Synthesis.SynthesizeState',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'tokenThreshold',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'unpause',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'versionRecipient',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'pure',
        type: 'function',
    },
]

const _bytecode =
    '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'

type SynthesisConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>

const isSuperArgs = (xs: SynthesisConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
    xs.length > 1

export class Synthesis__factory extends ContractFactory {
    constructor(...args: SynthesisConstructorParams) {
        if (isSuperArgs(args)) {
            super(...args)
        } else {
            super(_abi, _bytecode, args[0])
        }
        this.contractName = 'Synthesis'
    }

    deploy(overrides?: Overrides & { from?: string | Promise<string> }): Promise<Synthesis> {
        return super.deploy(overrides || {}) as Promise<Synthesis>
    }
    getDeployTransaction(overrides?: Overrides & { from?: string | Promise<string> }): TransactionRequest {
        return super.getDeployTransaction(overrides || {})
    }
    attach(address: string): Synthesis {
        return super.attach(address) as Synthesis
    }
    connect(signer: Signer): Synthesis__factory {
        return super.connect(signer) as Synthesis__factory
    }
    static readonly contractName: 'Synthesis'
    public readonly contractName: 'Synthesis'
    static readonly bytecode = _bytecode
    static readonly abi = _abi
    static createInterface(): SynthesisInterface {
        return new utils.Interface(_abi) as SynthesisInterface
    }
    static connect(address: string, signerOrProvider: Signer | Provider): Synthesis {
        return new Contract(address, _abi, signerOrProvider) as Synthesis
    }
}
